import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import Footer from "@/components/Footer";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        <Link to="/">
          <Button variant="ghost" className="mb-8 gap-2">
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Button>
        </Link>

        <h1 className="text-4xl font-bold mb-8">Termos de Uso</h1>
        
        <div className="prose prose-neutral max-w-none space-y-8 text-muted-foreground">
          <p className="text-lg">
            Última atualização: Janeiro de 2025
          </p>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e usar a plataforma Nutri IA, você concorda em cumprir e estar vinculado a estes Termos de Uso. 
              Se você não concordar com qualquer parte destes termos, não poderá acessar ou usar nossos serviços.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">2. Descrição do Serviço</h2>
            <p>
              A Nutri IA é uma plataforma de gestão para nutricionistas que oferece ferramentas de inteligência 
              artificial para automatização de consultas, criação de planos alimentares, agendamento e comunicação 
              com pacientes.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">3. Elegibilidade</h2>
            <p>
              Para usar nossos serviços, você deve:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Ser maior de 18 anos</li>
              <li>Ser um profissional de nutrição devidamente registrado no conselho competente</li>
              <li>Fornecer informações verdadeiras e precisas durante o cadastro</li>
              <li>Manter a confidencialidade de suas credenciais de acesso</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">4. Uso da Plataforma</h2>
            <p>Você concorda em:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Usar a plataforma apenas para fins legais e profissionais</li>
              <li>Não compartilhar suas credenciais de acesso com terceiros</li>
              <li>Manter a confidencialidade dos dados dos seus pacientes</li>
              <li>Não usar a plataforma para qualquer atividade fraudulenta ou ilegal</li>
              <li>Não tentar acessar áreas restritas ou comprometer a segurança da plataforma</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">5. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo da plataforma, incluindo textos, gráficos, logotipos, ícones, imagens, clipes de 
              áudio, downloads digitais e compilações de dados, é propriedade da Nutri IA ou de seus fornecedores 
              de conteúdo e está protegido pelas leis de direitos autorais.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">6. Responsabilidades do Usuário</h2>
            <p>
              Você é o único responsável por:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>A precisão das informações inseridas na plataforma</li>
              <li>As decisões clínicas tomadas com base nas sugestões da IA</li>
              <li>A obtenção de consentimento dos pacientes para uso de seus dados</li>
              <li>O cumprimento das normas éticas e legais da profissão</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">7. Limitação de Responsabilidade</h2>
            <p>
              A Nutri IA é uma ferramenta de apoio e não substitui o julgamento profissional. Não nos 
              responsabilizamos por decisões clínicas tomadas com base nas informações fornecidas pela plataforma. 
              O profissional deve sempre exercer seu julgamento clínico independente.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">8. Pagamentos e Assinaturas</h2>
            <p>
              Os termos de pagamento serão apresentados no momento da contratação. O cancelamento da assinatura 
              pode ser feito a qualquer momento, mas não haverá reembolso proporcional do período não utilizado, 
              exceto quando exigido por lei.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">9. Modificações dos Termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entrarão em 
              vigor após a publicação na plataforma. O uso continuado após as modificações constitui aceitação 
              dos novos termos.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">10. Rescisão</h2>
            <p>
              Podemos suspender ou encerrar seu acesso à plataforma a qualquer momento, por qualquer motivo, 
              incluindo violação destes termos. Você pode encerrar sua conta a qualquer momento entrando em 
              contato com nosso suporte.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">11. Lei Aplicável</h2>
            <p>
              Estes termos serão regidos e interpretados de acordo com as leis do Brasil. Qualquer disputa 
              será resolvida nos tribunais competentes da cidade de São Paulo, SP.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">12. Contato</h2>
            <p>
              Para dúvidas sobre estes Termos de Uso, entre em contato através do e-mail: contato@nutri-ia.com.br
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <Link to="/">
            <Button variant="ghost" className="gap-2">
              <ArrowLeft className="w-4 h-4" />
              Voltar para a página inicial
            </Button>
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;